import GreenCheckIcon from '../../assets/images/icons/GreenCheckIcon';
import RedCrossIcon from '../../assets/images/icons/RedCrossIcon';
import GreyCircleIcon from '../../assets/images/icons/GreyCircleIcon';
import styles from './CallHistory.module.scss';
import { CallBasedInteractions } from 'src/pages/CaseDetails/interfaces/CaseDetail.type';
import { DateFormat, dateFormat, utcToIST } from 'src/utils/DateHelper';
import { FeedbackTypesCodeMap } from 'src/pages/Cases/constants/CasesConstants';
import { Tooltip, TooltipContent, TooltipTrigger } from '../TooltipV2/TooltipV2';
import cx from 'classnames';
import { Typography } from '@navi/web-ui/lib/primitives';
const NO_OF_RECORDS = 5;

const CONNECTED_INTERACTIONS = new Set([
  'PROMISE_TO_PAY',
  'CALLBACK',
  'DISPUTE',
  'MESSAGE_LEFT',
  'REFUSED_TO_PAY',
  'CUSTOMER_EXPIRED',
  'PAID'
]);

interface ICallStatusProps {
  callRecordTag: string;
  interactionTimestamp: string;
  tooltip: React.ReactNode;
}

interface ICallInteractionsProps {
  callBasedInteractions: CallBasedInteractions[];
  noOfRecords: number;
  showTooltip?: boolean;
}

const CallStatus = (props: ICallStatusProps) => {
  const { callRecordTag, tooltip } = props;
  return (
    <Tooltip placement="top" tooltipGap={10}>
      <TooltipTrigger>
        {CONNECTED_INTERACTIONS.has(callRecordTag) ? (
          <GreenCheckIcon width={27} height={27} />
        ) : (
          <RedCrossIcon width={27} height={27} />
        )}
      </TooltipTrigger>
      <TooltipContent className={cx('tooltipWrapper', styles.toolTipStyle)}>
        {tooltip}
      </TooltipContent>
    </Tooltip>
  );
};

const CallStatusList = ({
  callBasedInteractions,
  noOfRecords,
  showTooltip
}: ICallInteractionsProps) => (
  <>
    {callBasedInteractions?.map(callRecord => (
      <CallStatus
        key={`call-checked-${callRecord.interactionTimestamp}`}
        callRecordTag={callRecord.tag}
        interactionTimestamp={callRecord.interactionTimestamp}
        tooltip={
          showTooltip ? (
            <div>
              <Typography variant="p1" className={styles.tooltipText}>
                Call Date and Time:{' '}
                {dateFormat(
                  utcToIST(new Date(callRecord.interactionTimestamp)),
                  DateFormat.LONG_DATE_FORMAT_WITH_TIME
                )}{' '}
              </Typography>
              <Typography variant="p1" className={styles.tooltipText}>
                Disposition: {FeedbackTypesCodeMap[callRecord?.tag]?.label || callRecord?.tag}
              </Typography>
              <Typography variant="p1" className={styles.tooltipText}>
                Phone Number: {callRecord?.recipientNumber}
              </Typography>
            </div>
          ) : (
            ''
          )
        }
      />
    ))}
    {[...Array(noOfRecords - callBasedInteractions?.length)].map((_, index) => (
      <GreyCircleIcon width={27} height={27} key={`no-call-${index}`} />
    ))}
  </>
);

const CallInteractionHistory = ({
  callBasedInteractions = [],
  noOfRecords = NO_OF_RECORDS,
  showTooltip
}: ICallInteractionsProps) => {
  return (
    <div className={styles.callHistory}>
      <CallStatusList
        callBasedInteractions={callBasedInteractions}
        noOfRecords={noOfRecords}
        showTooltip={showTooltip}
      />
    </div>
  );
};

export default CallInteractionHistory;
